var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYouTubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    onClick: "{onClick} ",
    className: "{className} ",
    viewBox: "0 0 68 48",
    width: 68,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ytp-large-play-button-bg",
    d: "M.66,37.88a8,8,0,0,0,5.67,5.67C10.8,44.6,34,44.6,34,44.6s23.2,0,27.68-1.05a8,8,0,0,0,5.67-5.67A75.11,75.11,0,0,0,68,24,75.11,75.11,0,0,0,67.35,10.12a8,8,0,0,0-5.67-5.67C57.2,3.4,34,3.4,34,3.4s-23.2,0-27.68,1.05a8,8,0,0,0-5.67,5.67A75.11,75.11,0,0,0,0,24,75.11,75.11,0,0,0,.66,37.88Z",
    fill: "#F2F3F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45,24,27,14v20Z",
    fill: "#757780"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTubeIcon);
export default __webpack_public_path__ + "static/media/YouTubeIcon.261cc6d3d016dc6a431836be6bf1c4cb.svg";
export { ForwardRef as ReactComponent };